import React, { useState, useContext } from "react";
import style from "./CriarCategoriaStyle";
import { criarCategoria } from "../../../../Services/dbservice";
import { AuthContext } from "../../../../Context/AuthContext";
import { FiX } from "react-icons/fi";
import toast from 'react-hot-toast';

export default function CriarCategoria({ onClose }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { credentials } = useContext(AuthContext);

  const createCategory = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error("O nome da categoria é obrigatório.");
      return;
    }
    setIsSubmitting(true);
    try {
      await criarCategoria({ name, description }, credentials.accessToken);
      toast.success("Categoria criada com sucesso!");
      onClose();
    } catch (err) {
      console.error("Erro ao criar categoria:", err);
      toast.error("Falha ao criar categoria. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={style.overlay} onClick={onClose}>
      <div style={style.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div style={style.modalHeader}>
          <h2 style={style.modalTitle}>Criar Nova Categoria</h2>
          <button onClick={onClose} style={style.closeButton}><FiX size={20} /></button>
        </div>
        <form onSubmit={createCategory} style={style.form}>
          <div style={style.inputGroup}>
            <label style={style.label}>Nome da Categoria</label>
            <input
              onChange={(e) => setName(e.target.value)}
              value={name}
              maxLength={30}
              placeholder="Ex: Eletrônicos"
              style={style.input}
              disabled={isSubmitting}
            />
          </div>
          <div style={style.inputGroup}>
            <label style={style.label}>Descrição (opcional)</label>
            <textarea
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              maxLength={100}
              style={{...style.input, ...style.textarea}}
              placeholder="Descreva para que serve esta categoria..."
              disabled={isSubmitting}
            />
          </div>
          <button type="submit" style={style.submitButton} disabled={isSubmitting || !name.trim()}>
            {isSubmitting ? "Criando..." : "Criar Categoria"}
          </button>
        </form>
      </div>
    </div>
  );
}